module.exports = __webpack_public_path__ + "static/media/like.739c0ccd.svg";